import { render, staticRenderFns } from "./Measuringunit.vue?vue&type=template&id=98f224e2&scoped=true"
import script from "./Measuringunit.vue?vue&type=script&lang=js"
export * from "./Measuringunit.vue?vue&type=script&lang=js"
import style0 from "./Measuringunit.vue?vue&type=style&index=0&id=98f224e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f224e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98f224e2')) {
      api.createRecord('98f224e2', component.options)
    } else {
      api.reload('98f224e2', component.options)
    }
    module.hot.accept("./Measuringunit.vue?vue&type=template&id=98f224e2&scoped=true", function () {
      api.rerender('98f224e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Measuringunit/Measuringunit.vue"
export default component.exports